export const PLUGIN_CUSTOM_PROPS = {
    width: 14,
    height: 14,
    customRadiusMax: 7,
    customRadiusMin: 3,
    customLineWidth: 1.5,
    customInsideElemWidth: 2,
    defaultPosition: { x: 1.5, y: 1.5 }
};
